import styled from 'styled-components';

export const RouteSimulatorStyle = styled.div`
  .ant-select,
  .ant-input-number {
    width: 100%;
  }
  .simulation-presets {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
  }
  .simulation-result {
    margin-top: 24px;
    padding: 24px;
    background: #f4f1fc;
    border-radius: 8px;
  }
  .simulation-pg {
    display: block;
    color: var(--settings-accent);
    font-size: 21px;
    font-weight: 650;
    margin: 6px 0;
  }
  .simulation-account {
    margin-top: 12px;
    color: #626e7f;
    font-size: 12px;
    overflow-wrap: anywhere;
  }
  .simulation-note {
    font-size: 12px;
    color: #626e7f;
    margin: 20px 0 0;
    line-height: 1.6;
  }
`;
